import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import Head from "next/head";
import AppbarIndustry from "../../../../components/AppbarIndustry";
import HeroSection from "../../../../components/HeroSection";
import TitleIndustry from "../../../../components/TitleIndustry";
import HeroEnquiryFormIndustry from "../../../../components/HeroEnquiryFormIndustry";
import FooterIndustry from "../../../../components/FooterIndustry";
import { ourProducts } from "../../../../components/chemical/data";
import StickyWhatsappIndustries from "../../../../components/StickyWhatsappIndustries";

function AutonomousSurveillance() {
  const products = [
    
    "Chemical Inventory Management Systems",
    

  ];
  const data = {
    image: "/industries/chemical/chemical-inventory-management-systems.jpg", // Replace with the appropriate image URL
    intro: `Present state-of-the-art systems for managing chemical inventories, ensuring accurate tracking, compliance, and safety within chemical storage facilities.`,
    keyFeatures: [
        {
            title: "Barcode or RFID-based inventory tracking",
            content: "Implement barcode or RFID-based systems for accurate tracking of chemical inventories, improving efficiency and reducing errors.",
        },
        {
            title: "Chemical hazard classification and labeling",
            content: "Classify chemicals based on hazards and ensure proper labeling for easy identification and adherence to safety protocols.",
        },
        {
            title: "Real-time stock monitoring",
            content: "Monitor chemical stock levels in real-time, allowing for proactive management and preventing shortages or overstock situations.",
        },
        {
            title: "Integration with safety data sheets (SDS)",
            content: "Integrate with safety data sheets to provide comprehensive information on chemical properties, hazards, and safe handling procedures.",
        },
        {
            title: "Automated reorder alerts",
            content: "Set up automated alerts for reordering chemicals, optimizing inventory control and ensuring a continuous supply.",
        },
    ],
    howItWorks: `Explain the mechanisms employed to track and manage chemical inventories, from the initial entry to usage and disposal, ensuring safety and compliance.`,
    benefits: {
        title: "The benefits of Chemical Inventory Management Systems",
        data: [
            "Enhanced chemical safety through accurate tracking and hazard classification.",
            "Compliance with storage regulations and safety protocols.",
            "Efficient inventory control leading to waste reduction.",
            "Streamlined procurement processes for cost-effective management.",
        ],
    },
    industries: "Critical for chemical manufacturing, research facilities, and any organization handling hazardous materials.",
    stories: `Highlight instances where the systems have improved safety, compliance, and overall efficiency in managing chemical inventories.`,
    contactUs: `Provide contact information for inquiries and support related to Chemical Inventory Management Systems.`,
    futureDevelopments: `Discuss upcoming features and innovations in chemical inventory management technology, ensuring continuous improvement.`,
    technology: `Explore how the systems seamlessly integrate with existing inventory and safety management protocols.`,
    support: `Offer resources for user training and support to ensure effective utilization of Chemical Inventory Management Systems.`,
    industry: `Explain how the systems adhere to industry standards and regulatory requirements for chemical storage.`,
    events: "Keep users informed about industry events and potential collaborations in the realm of chemical inventory management.",
    blog: `Provide a platform for articles, case studies, and expert insights in a blog and knowledge hub dedicated to best practices in chemical inventory management.`,
    careers: `Invite individuals to explore career opportunities contributing to the development and enhancement of Chemical Inventory Management Systems. Join us in promoting safe and compliant chemical handling.`,
};

  
  
  const content = "Embark on a chemical innovation journey with us! Whether you're delving into chemical technology, process optimization, sustainability solutions, or any facet of the chemical industry, we offer tailored solutions. Our expertise spans projects of various scales, ensuring our chemical solutions align seamlessly with your goals, budget, and scope."
    return (
    <>
       <Head>
       
<title>Chemical Inventory Management Systems</title>
<meta name="description" content="Discover our industry-leading chemical inventory management systems designed to streamline inventory tracking, ensure regulatory compliance, and optimize chemical supply chain operations. Explore cutting-edge technology for efficient chemical inventory management." />
       
<Head>
    <title>Chemical Inventory Management Systems | Techbrain Networks</title>
    <meta name="description" content="Track and manage chemical inventories efficiently with Techbrain Networks Chemical Inventory Management Systems. Ensure safety and compliance." />
    <meta name="keywords" content="chemical inventory management, chemical tracking, chemical safety, inventory management software, Techbrain Networks" />
    <meta property="og:title" content="Chemical Inventory Management Systems | Techbrain Networks" />
    <meta property="og:description" content="Techbrain Networks Chemical Inventory Management Systems help you manage chemical stocks efficiently, ensuring compliance with industry standards." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.techbrainnetworks.com/industries/chemical/products/chemical-inventory-management-systems" />
    <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta property="og:image:alt" content="Chemical Inventory Management Systems" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Chemical Inventory Management Systems | Techbrain Networks" />
    <meta name="twitter:description" content="Manage chemical inventories safely and efficiently with Techbrain Networks Inventory Management Systems." />
     <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpgg" />
    <link rel="canonical" href="https://www.techbrainnetworks.com/industries/chemical/products/chemical-inventory-management-systems" />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Chemical Inventory Management Systems",
        "image": "https://www.techbrainnetworks.com/logo-tbn.jpg",
        "description": "Track and manage chemical inventories efficiently with Techbrain Networks Chemical Inventory Management Systems.",
        "brand": "Techbrain Networks",
        "offers": {
            "@type": "Offer",
            "url": "https://www.techbrainnetworks.com/industries/chemical/products/chemical-inventory-management-systems",
            "priceCurrency": "USD",
            "price": "Contact for pricing"
        }
    })}} />
</Head>

        {/* Add other SEO meta tags as needed */}
        <link rel="icon" href="/favicon.png" />
      </Head>
      <AppbarIndustry title={"Chemical"} homeLink={'/industries/chemical'} link={'/industries/chemical/products'} />
      <StickyWhatsappIndustries link={"https://api.whatsapp.com/send?phone=918754906714"}  color={"#673bbf"} />
      <HeroSection img={"/industries/chemical/chemical-inventory-management-systems.jpg"}>Chemical Inventory Management Systems
</HeroSection>
      <Box
        sx={{
          px: [0, "1.2rem", "3.8rem", "3rem"],
          pb: [1, 1, 2, 2, 4],
          bgcolor: "#04010a",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {/* intro */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",

            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#673bbf"}>Introduction</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.intro}
          </Typography>
        </Box>
         {/* Key Features Unleashed */}
         <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", ".5rem", "1.5rem", "1.5rem", "1rem"],
          }}
        >
          <TitleIndustry color={"#673bbf"}>Key Features Unleashed</TitleIndustry>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: ["column", "row"],
              flexWrap: "wrap",
              justifyContent: [null, "space-between", "flex-start"],
              gap: ["2rem", "1rem", "2rem", "2rem", "2rem"],
            }}
          >
            {data.keyFeatures.map((i, k) => (
              <Box
                sx={{
                  display: "flex",
                  width: ["95%", "45%", "30%"],
                  flexDirection: "column",
                  gap: ["0.5rem", "0.5rem", "0.5rem", "0.5rem", "1rem"],
                }}
              >
                <Typography
                  sx={{
                    fontSize: [
                      "1.3rem",
                      "1.2rem",
                      "1.2rem",
                      "1.4rem",
                      "1.5rem",
                    ],
                    fontWeight: "bold",
                    color: "#673bbf",
                  }}
                >
                  {i.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {i.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        {/* how it works */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#673bbf"}>How It Works?</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.howItWorks}
          </Typography>
        </Box>
        {/* benefits */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", "1.5rem", ".5rem"],
          }}
        >
          <Stack
            direction={"column"}
            sx={{
              width: ["100%", "48%"],
            }}
          >
            <TitleIndustry color={"#673bbf"}>Benefits</TitleIndustry>
            <Typography
              sx={{
                fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                color: "#fff",
              }}
            >
              {data.benefits.title}:
            </Typography>

            <Stack
              direction={"column"}
              sx={{
                gap: [1, 1, 2],
                mt: [3, 3, 4],
              }}
            >
              {data.benefits.data.map((i, k) => (
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {"•  "}
                  {i}
                </Typography>
              ))}
            </Stack>
          </Stack>

          <Box
            sx={{
              width: ["100%", "50%", "45%"],
              height: ["20rem", "20rem", "20rem", "25rem", "30rem"],
              backgroundImage: `url(${data.image})`,
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundrepeat: "no-repeat",
              borderRadius: "16px",
            }}
          />
        </Stack>
       {/* Industries */}
       <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#673bbf"}>Industries</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industries}
          </Typography>
        </Box>

        

        {/* Future Developments and Innovations*/}
 
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#673bbf"}>Future Developments and Innovations</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
           Stay informed about upcoming features and innovations in autonomous surveillance and reconnaissance technology
          </Typography>
        </Box>

        {/* Technology Integration */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#673bbf"}>Technology Integration</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.technology}
          </Typography>
        </Box>

        {/* User Training and Support */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#673bbf"}>User Training and Support</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.support}
          </Typography>
        </Box>

        {/*  Industry Standards and Compliance */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#673bbf"}> Industry Standards and Compliance</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industry}
          </Typography>
        </Box>

       

        <Box
          sx={{
            width: "100%",
          
            display: "flex",
            gap: "1rem",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: ["2rem", "3rem", "3rem", "4rem"],
                fontWeight: "bold",
                color: "#673bbf",
                textAlign: "center",
              }}
            >
              Contact
            </Typography>
          </Box>
          <Box
            sx={{
              width: [ "100%"],
              display: "flex",
              justifyContent: "center",
              padding:'1rem'
            }}
          >
            <HeroEnquiryFormIndustry color={"#673bbf"} products={products} content={content}/>
          </Box>
        </Box>
      </Box>
      <FooterIndustry ourProducts={ourProducts} color={"#673bbf"} bg={"#04010a"} />
    </>
  );
}

export default AutonomousSurveillance;
